//This file is automatically rebuilt by the Cesium build process.
export default "/**\n\
 * The automatic GLSL constant for {@link Pass#GLOBE}\n\
 *\n\
 * @name czm_passGlobe\n\
 * @glslConstant\n\
 *\n\
 * @see czm_pass\n\
 */\n\
const float czm_passGlobe = 2.0;\n\
";
